"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureStore = void 0;
const redux_1 = require("redux");
const combineReducers_1 = require("./combineReducers");
function configureStore(config) {
    const preloadedState = config.preloadedState;
    const reducers = config.reducers;
    const middlewares = config.middlewares;
    let finalCompose = redux_1.compose;
    if (config.devToolOptions && !config.devToolOptions.disabled) {
        const devToolCompose = config.devToolOptions.devToolCompose;
        if (devToolCompose) {
            finalCompose = devToolCompose(config.devToolOptions);
        }
    }
    const combinedMiddleware = redux_1.applyMiddleware(...middlewares);
    const composedMiddlewares = finalCompose(combinedMiddleware);
    const combinedReducer = combineReducers_1.combineReducers(reducers);
    // preloaded state must be an object
    const store = preloadedState ?
        redux_1.createStore(combinedReducer, preloadedState, composedMiddlewares) :
        redux_1.createStore(combinedReducer, composedMiddlewares);
    return store;
}
exports.configureStore = configureStore;
